import { Portal as ChakraPortal } from '@chakra-ui/react'

export const Portal = ChakraPortal
